var _defs, _g, _circle;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHomeRounded(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 119 119",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "d2r9a5wz3a",
    x: "-400%",
    width: "600%",
    y: "-400%",
    height: "600%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "SourceAlpha",
    stdDeviation: "0,0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0,
    result: "tmp"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(228,228,228)"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "tmp"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", null), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M59.500000,0L119,0L119,119L59.500000,119C26.639057,119,0,92.360943,0,59.500000L0,59.500000C0,26.639057,26.639057,0,59.500000,0Z",
    transform: "matrix(1 0 0 1 0.26200194999998 0.07000002499996)",
    filter: "url(#d2r9a5wz3a)",
    fill: "rgb(255,255,255)",
    stroke: "none",
    strokeWidth: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.500000,104.490000C34.647186,104.490000,14.500000,84.342814,14.500000,59.490000C14.500000,34.637186,34.647186,14.490000,59.500000,14.490000C84.352814,14.490000,104.500000,34.637186,104.500000,59.490000C104.500000,84.342814,84.352814,104.490000,59.500000,104.490000ZM59.620000,21.550000C38.467494,21.550000,21.320000,38.697494,21.320000,59.850000C21.320000,81.002506,38.467494,98.150000,59.620000,98.150000C80.772506,98.150000,97.920000,81.002506,97.920000,59.850000C97.903456,38.704351,80.765649,21.566544,59.620000,21.550000Z",
    fill: "rgb(18,83,250)",
    stroke: "none",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#w0vgtctipb)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M83,55.260000L61.050000,35.930000C59.987710,35.031923,58.432290,35.031923,57.370000,35.930000L35.480000,55.260000C34.480000,56.150000,34.730000,56.880000,36.100000,56.880000L42.850000,56.880000L42.850000,76.660000C42.850000,77.764569,43.745431,78.660000,44.850000,78.660000L53.110000,78.660000L53.110000,65.660000C53.110000,64.555431,54.005431,63.660000,55.110000,63.660000L63.400000,63.660000C63.930433,63.660000,64.439141,63.870714,64.814214,64.245786C65.189286,64.620859,65.400000,65.129567,65.400000,65.660000L65.400000,78.660000L73.660000,78.660000C74.764569,78.660000,75.660000,77.764569,75.660000,76.660000L75.660000,56.880000L82.420000,56.880000C83.680000,56.880000,84,56.160000,83,55.260000Z",
    fill: "rgb(18,83,250)",
    fillOpacity: 0.5,
    stroke: "rgb(18,83,250)",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "w0vgtctipb"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 38.5,
    transform: "matrix(1 0 0 1 59.04000000000000 59.57000000000000)",
    fill: "none",
    stroke: "rgb(3,20,250)",
    strokeWidth: 1
  })))))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    r: 27.5,
    transform: "matrix(1.56346237451626 0 0 1.56346237451626 59.50892662000001 59.24692466999996)",
    fill: "none",
    stroke: "rgb(18,83,250)",
    strokeWidth: 0.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeRounded);
export default __webpack_public_path__ + "static/media/home-rounded.567af600.svg";
export { ForwardRef as ReactComponent };